export default defineNuxtRouteMiddleware((to) => {
  const { $enabled } = useNuxtApp();
  if (!$enabled('content.enablebigcitylife')) return navigateTo('/blog');

  if (
    to.path.startsWith('/big-city-life') ||
    to.path.startsWith('/big-city-lights')
  )
    return navigateTo(`/blog${to.path}`);
});
